(function () {
  var MIN_SPEED_SECONDS = 1;
  var MAX_SPEED_SECONDS = 10;
  var DEFAULT_SPEED_SECONDS = 3;
  var MAX_WAIT_FOR_IMAGE_MS = 2000;

  function getThumbnailButtons(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-target] button'));
  }

  function getCurrentIndex(thumbs) {
    var index = -1;
    thumbs.forEach(function (btn, i) {
      if (btn.getAttribute('aria-current') === 'true') index = i;
    });
    return index;
  }

  function getSlide(gallery, thumbButton) {
    var item = thumbButton.closest('[data-target]');
    if (!item) return null;
    return gallery.querySelector('[data-media-id="' + item.dataset.target + '"]');
  }

  function isImageThumbnail(gallery, thumbButton) {
    var slide = getSlide(gallery, thumbButton);
    return !slide || !slide.classList.contains('product__media-item--full');
  }

  function getSlideImage(gallery, thumbButton) {
    var slide = getSlide(gallery, thumbButton);
    return slide ? slide.querySelector('img') : null;
  }

  function isImageReady(img) {
    return !!img && img.complete && img.naturalWidth > 0;
  }

  function preloadSlideImage(gallery, thumbButton) {
    var img = getSlideImage(gallery, thumbButton);
    if (!img || isImageReady(img)) return;

    if (img.loading === 'lazy') img.loading = 'eager';
    var warmer = new Image();
    if (img.sizes) warmer.sizes = img.sizes;
    if (img.srcset) warmer.srcset = img.srcset;
    warmer.src = img.currentSrc || img.src;
  }

  function initGallery(gallery) {
    if (gallery.dataset.autoplay !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (gallery.closest('quick-add-modal, quick-add-bulk')) return;

    var thumbs = getThumbnailButtons(gallery);
    if (thumbs.length < 2) return;

    var speedSeconds = parseFloat(gallery.dataset.speed);
    if (isNaN(speedSeconds)) speedSeconds = DEFAULT_SPEED_SECONDS;
    speedSeconds = Math.min(Math.max(speedSeconds, MIN_SPEED_SECONDS), MAX_SPEED_SECONDS);
    var intervalMs = speedSeconds * 1000;

    var currentIndex = getCurrentIndex(thumbs);
    if (currentIndex === -1) currentIndex = 0;

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        currentIndex = i;
      });
    });

    var timer = null;
    var modalOpen = false;
    var advancing = false;

    function findNextIndex() {
      var rawNextIndex = (currentIndex + 1) % thumbs.length;
      var nextIndex = rawNextIndex;

      for (var i = 0; i < thumbs.length; i++) {
        var candidate = (rawNextIndex + i) % thumbs.length;
        if (isImageThumbnail(gallery, thumbs[candidate])) {
          nextIndex = candidate;
          break;
        }
      }

      return nextIndex;
    }

    function advanceTo(nextIndex) {
      thumbs[nextIndex].click();
      advancing = false;
      preloadSlideImage(gallery, thumbs[findNextIndex()]);
    }

    function tick() {
      if (advancing) return;

      var nextIndex = findNextIndex();
      var nextImg = getSlideImage(gallery, thumbs[nextIndex]);

      if (!nextImg || isImageReady(nextImg)) {
        advanceTo(nextIndex);
        return;
      }

      advancing = true;
      preloadSlideImage(gallery, thumbs[nextIndex]);

      var settled = false;
      var onSettle = function () {
        if (settled) return;
        settled = true;
        nextImg.removeEventListener('load', onSettle);
        nextImg.removeEventListener('error', onSettle);
        advanceTo(nextIndex);
      };

      nextImg.addEventListener('load', onSettle, { once: true });
      nextImg.addEventListener('error', onSettle, { once: true });
      window.setTimeout(onSettle, MAX_WAIT_FOR_IMAGE_MS);
    }

    function play() {
      if (timer || modalOpen || document.hidden) return;
      timer = window.setInterval(tick, intervalMs);
    }

    function pause() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    gallery.addEventListener('mouseenter', pause);
    gallery.addEventListener('mouseleave', play);
    gallery.addEventListener('focusin', pause);
    gallery.addEventListener('focusout', play);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else {
        play();
      }
    });

    new MutationObserver(function () {
      modalOpen = document.body.classList.contains('overflow-hidden');
      if (modalOpen) {
        pause();
      } else {
        play();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    preloadSlideImage(gallery, thumbs[findNextIndex()]);

    play();
  }

  function init() {
    document.querySelectorAll('media-gallery[data-autoplay="true"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
